import styled, { css } from 'styled-components';

export const textBlock = css`
  margin: 10px 0 6px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .card-text {
    margin-bottom: 0 !important;
  }

  h2 {
    font-size: 18.29px;
    line-height: 20px;
    font-weight: 700;

    @media (max-width: 794px) {
      font-size: 18px;
      line-height: 28px;
    }
  }

  @media (max-width: 794px) {
    margin: 20px 0;
  }
`;

export const redSmallDateStyling = css`
  color: #e60000;
  font-size: 14px;
  padding-bottom: 15px;
`;

export const iconTextStyle = css`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  margin-bottom: 5px;

  :last-child {
    margin-bottom: 0;
  }

  @media (max-width: 794px) {
    margin-bottom: 8px;
  }

  svg {
    margin-right: 10px;
    width: 26px;
    height: 100%;

    @media (max-width: 794px) {
      width: 32px;
    }
  }
`;

export const imageIconStyle = css`
  width: 48px;
  height: 48px;
  position: absolute;
  top: 235px;
  left: 20px;
  z-index: 10;
  padding-top: 6px;
  padding-left: 7px;
  border-radius: 7px;
  background-color: #e60000;
`;

export const redTextLinkWrapper = css`
  color: #bd0000;
  padding: 0 20px;
  width: fit-content;
  position: absolute;
  bottom: 20px;

  .red-text-link {
    display: flex;
    text-decoration: none;
    border-bottom: 0em solid transparent;
  }

  .red-text-link-icon {
    .injected-svg {
      stroke: #bd0000 !important;
    }
  }

  .red-text-link-label {
    padding-top: 1px;
  }

  @media (max-width: 794px) {
    display: none;
  }
`;

export const imageBlock = css`
  border-radius: 4px;
  object-fit: cover;
  object-position: 50% 50%;
  width: 100%;
  max-width: 100%;
  margin: 0;
  height: 217px;

  img {
    width: 100%;
  }

  @media (max-width: 794px) {
    height: 162px;
  }
`;

export const ContainerWrapper = styled.div`
  [class*='Containerstyle__Container-sc'] {
    padding: 13.07px;

    @media (max-width: 794px) {
      padding: 20px;
    }
  }
`;

export const IconTextContent = styled.span`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  @media (max-width: 794px) {
    font-size: 16px;
    font-style: normal;
    line-height: 20px;
  }
`;
